import './carouselBackground.css';
import expensibleOffice from '../carouselImages/expensible_office.png';
import van from '../carouselImages/van.jpeg';
import towing from '../carouselImages/towing.jpeg'; 
import trucking from '../carouselImages/trucking.jpeg';
import tracktor from '../carouselImages/tracktor.jpeg';
import manu from '../carouselImages/manu.jpeg';
import logging from '../carouselImages/logging.jpeg';
import cons from '../carouselImages/cons.jpeg';
import fork from '../carouselImages/fork.jpeg';

export default function CarouselBackground({carouselIndexImg, imgPopIndex}) {

    const carouselImagesArray = [expensibleOffice, van, towing, trucking, tracktor, manu, logging, cons, fork];

    const carouselSelectedIndex = {
        '--background-carousel-image': `url("${carouselImagesArray[carouselIndexImg]}")`
    };

    const imgPop = ['img-pop', 'img-pop-two']



    return (
        <div>
        <div className={`carousel-background ${imgPop[imgPopIndex]}`} style={carouselSelectedIndex}></div>
        <div className="carousel-background-overlay"></div>
        </div>
    )
}